<div class="connection-banner" *ngIf="isDown" role="alert">
    <span class="spinner"></span>
    <span>Reconectando con el servidor...</span>
</div>
